import React from 'react';
import styled from 'styled-components';
import SimpleCarousel from '@flow/components/carousel/SimpleCarousel';

const BannerWrapper = styled.div`
  position: relative;
  width: 100%;
  max-width: 98em;
  margin: 4em auto 0;
  
  @media (max-width: 900px) {
    max-width: 30em;
  }
`;

const BannerImage = styled.figure`
  width: 100%;
  padding-top: 12.246%;  
  background-size: cover;
  background-repeat: no-repeat;
`;

const Banner = styled.a`
  display: block;
  width: 100%; 
  ${BannerImage} {
    background-image: url(${props => props.theme.isRetina ? props.desktopImage['default'] : props.desktopImageRetina['default']});
    
    @media (max-width: 900px) {
      padding-top: 100%;   
      background-image: url(${props => props.theme.isRetina ? props.mobileImage['default'] : props.mobileImageRetina['default']}); 
    }  
  }
`;

interface Image {
  caption?: string;
  default?: string;
  large?: string;
  medium_large?: string;
  medium?: string;
  small_medium?: string;
  small?: string;
  thumbnail?: string;
}

interface Ad {
  link?: {
    title?: string;
    url?: string;
    target?: string;
  },
  desktop_image?: Image;
  desktop_image_retina?: Image;
  mobile_image?: Image;
  mobile_image_retina?: Image;
}

interface Props {
  banners: {ads: Ad[]};
}

class AdLift extends React.PureComponent<Props> {
  render() {
    const {
      banners: {
        ads
      }
    } = this.props;
    if (ads) {
      const carouselSettings = {
        dots: false,
        arrows: false,
        autoplay: ads.length > 1,
        autoplaySpeed: 5000,
        pauseOnHover: true
      };

      return (
        <BannerWrapper>
          <SimpleCarousel settings={carouselSettings}>
            {ads.map((ad: Ad, index: number) =>
              <Banner
                key={index}
                href={ad.link.url}
                target='_blank'
                desktopImage={ad.desktop_image}
                desktopImageRetina={ad.desktop_image_retina}
                mobileImage={ad.mobile_image}
                mobileImageRetina={ad.mobile_image_retina}
              >
                <BannerImage/>
              </Banner>
            )}
          </SimpleCarousel>
        </BannerWrapper>
      )
    } else {
      return null;
    }
  }
}

export default AdLift;


// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/scenes/home/components/ad-lift/AdLift.tsx